module.exports = __webpack_public_path__ + "img/5.a79e625c.jpg";